// Bulk-select for tasks table.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "selectedCount", "selectionHeader"]

  connect() {
    this.lastChecked = null
    this.updateHeaderVisibility()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked
    })
    this.updateHeaderVisibility()
  }

  toggle(event) {
    if (event.shiftKey && this.lastChecked) {
      const checkboxes = this.checkboxTargets
      const start = checkboxes.indexOf(this.lastChecked)
      const end = checkboxes.indexOf(event.target)
      const range = [start, end].sort((a, b) => a - b)

      for (let i = range[0]; i <= range[1]; i++) {
        checkboxes[i].checked = event.target.checked
      }
    }

    this.lastChecked = event.target
    this.updateSelectAllState()
    this.updateHeaderVisibility()
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return

    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length

    this.selectAllTarget.checked = checked === total && total > 0
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }

  updateHeaderVisibility() {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length
    const hasSelection = checkedCount > 0

    // The selection bar sits above the table rather than replacing the column headers: those
    // are real <th>s now, and they carry the sort links and resize handles.
    if (this.hasSelectionHeaderTarget) {
      this.selectionHeaderTarget.classList.toggle("hidden", !hasSelection)
      this.selectionHeaderTarget.classList.toggle("flex", hasSelection)
    }

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedCount
    }
  }

  getSelectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  submitBulkAction(event) {
    const selectedIds = this.getSelectedIds()
    if (selectedIds.length === 0) {
      event.preventDefault()
      return false
    }
  }

  resetSelection() {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = false
    })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.updateHeaderVisibility()
  }
}
